import {useContext, useEffect} from 'react';
import {ConversationContext} from '@stripe-internal/conversations-client';
import {useWidgetTitle} from '@stripe-internal/conversations-ui';
import {UnrecoverableErrorScreen} from '../UnrecoverableErrorScreen';
import {LoadingScreen} from '../LoadingScreen';
import {ConversationScreen} from './ConversationScreen';
import {Title} from '../../components/Title';
import {ConfigContext} from '../../Providers/ConfigProvider';
import {useConversation} from './useConversation';

type Props = {
  conversationId?: string;
  context?: ConversationContext;
};

export function ChatScreen({conversationId, context = {}}: Props) {
  const {audience, entrypoint: entryPoint} = useContext(ConfigContext);

  const {setTitle} = useWidgetTitle();

  const {conversation, error, sentryEventId, restartConversation} =
    useConversation({
      conversationId,
      context: {
        audience,
        entryPoint,
        ...context,
      },
    });

  useEffect(() => {
    setTitle(<Title />);
  }, [setTitle]);

  if (error) {
    return <UnrecoverableErrorScreen sentryEventId={sentryEventId} />;
  }

  if (!conversation) {
    return <LoadingScreen />;
  }

  return (
    <ConversationScreen
      conversation={conversation}
      restartConversation={restartConversation}
    />
  );
}
